module.exports = __webpack_public_path__ + "img/reference-koerpertherapie.3f50a861.jpg";